export const CATEGORY_SCHEMA = "iglu:com.anyvan/category/jsonschema/1-0-0"
export const EXPERIMENT_SCHEMA = "iglu:com.anyvan/experiment/jsonschema/1-0-0"
export const SCROLL_SCHEMA = "iglu:com.anyvan/scroll_tracking/jsonschema/1-0-0"
export const LOCALE_SCHEMA = "iglu:com.anyvan/locale/jsonschema/1-0-0"
